import React from 'react';
import primaLogo from '../assets/images/logos/prima-logo.webp';

export default function SponsorshipDisplay({ 
  dancerName, 
  isSponsored, 
  size = 'small', 
  layout = 'horizontal',
  position = 'inline' // 'inline', 'card-corner', 'profile', 'inline-right'
}) {
  if (!isSponsored) return null;

  const logoSize = size === 'small' ? '12px' : size === 'medium' ? '16px' : '20px';
  const fontSize = size === 'small' ? '0.6rem' : size === 'medium' ? '0.7rem' : '0.8rem';
  
  const getContainerStyle = () => {
    const baseStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: layout === 'horizontal' ? '4px' : '3px',
      flexDirection: layout === 'vertical' ? 'column' : 'row',
      padding: size === 'small' ? '2px 6px' : '4px 8px',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      borderRadius: '4px',
      width: 'fit-content'
    };

    if (position === 'card-corner') {
      return {
        ...baseStyle,
        position: 'absolute',
        top: '8px',
        right: '8px',
        zIndex: 2
      };
    }

    if (position === 'profile') {
      return {
        ...baseStyle,
        marginTop: '12px',
        marginBottom: '8px'
      };
    }

    if (position === 'inline-right') {
      return {
        ...baseStyle,
        display: 'inline-flex',
        marginLeft: '12px',
        marginTop: '0',
        verticalAlign: 'middle',
        padding: '1px 4px'
      };
    }

    return {
      ...baseStyle,
      marginTop: '4px'
    };
  };

  const containerStyle = getContainerStyle();

  const textStyle = {
    fontSize: fontSize,
    color: '#ffffff',
    fontWeight: '500',
    margin: 0
  };

  const logoStyle = {
    height: logoSize,
    width: 'auto',
    objectFit: 'contain',
    cursor: 'pointer',
    transition: 'transform 0.2s ease'
  };

  return (
    <div style={containerStyle}>
      <span style={textStyle}>Shoes by</span>
      <a 
        href="https://primadance.gr" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ display: 'inline-block' }}
        onMouseEnter={(e) => e.target.firstChild.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.target.firstChild.style.transform = 'scale(1)'}
      >
        <img 
          src={primaLogo} 
          alt="Prima Dance Shoes" 
          style={logoStyle}
        />
      </a>
    </div>
  );
}
